// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plsqled-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.plsqled-modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 95%;
  max-width: 1500px;
  height: calc(90vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header */
.plsqled-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.plsqled-header h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.plsqled-header-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.plsqled-select {
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  min-width: 160px;
}

.plsqled-schema-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  color: #6b7280;
}

.plsqled-schema-input {
  width: 110px;
  padding: 3px 6px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  font-family: var(--font-mono);
  text-transform: uppercase;
}

.plsqled-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  padding: 4px;
  display: flex;
  align-items: center;
}
.plsqled-close:hover { color: #333; }

/* Empty state (연결 없음) */
.plsqled-empty-state {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #9ca3af;
  font-size: 13px;
}

/* Body layout */
.plsqled-body {
  flex: 1 1;
  display: flex;
  overflow: hidden;
  min-height: 0;
}

/* Sidebar */
.plsqled-sidebar {
  width: 240px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e0e0e0;
  background: #fafbfc;
}

.plsqled-sidebar-toolbar {
  display: flex;
  gap: 6px;
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.plsqled-btn-block { flex: 1 1; justify-content: center; }

.plsqled-icon-btn {
  background: none;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 4px 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #555;
}
.plsqled-icon-btn:hover:not(:disabled) { background: #f3f4f6; color: #333; }
.plsqled-icon-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.plsqled-recompile-btn { gap: 4px; color: #b45309; border-color: #fbbf24; }
.plsqled-recompile-btn:hover:not(:disabled) { background: #fffbeb; }
.plsqled-recompile-count {
  font-size: 10.5px;
  font-weight: 700;
  background: #fef3c7;
  color: #92400e;
  border-radius: 999px;
  padding: 0 5px;
  min-width: 14px;
  text-align: center;
}
.plsqled-recompile-progress { font-size: 11px; font-weight: 600; font-family: var(--font-mono); }

.plsqled-bulk-result {
  margin: 0 8px 6px;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 11.5px;
  background: #f0fdf4;
  border: 1px solid #86efac;
  color: #166534;
  animation: plsqled-fade-swap 160ms ease-out;
}
.plsqled-bulk-result.warn { background: #fffbeb; border-color: #fbbf24; color: #92400e; }
.plsqled-bulk-result-list { margin: 4px 0 0; padding-left: 16px; }
.plsqled-bulk-result-list li { line-height: 1.5; }
@media (prefers-reduced-motion: reduce) { .plsqled-bulk-result { animation: none; } }

.plsqled-search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-bottom: 1px solid #eee;
  color: #9ca3af;
}
.plsqled-search input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 12px;
  background: transparent;
  color: #374151;
}

.plsqled-object-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 4px 0;
}

.plsqled-object-group-label {
  padding: 6px 10px 3px;
  font-size: 10.5px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.03em;
}

.plsqled-object-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 5px 10px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 12.5px;
  color: #374151;
  transition: background-color 150ms ease;
}
.plsqled-object-row:hover { background: #f3f4f6; }
.plsqled-object-row.active { background: #eff6ff; color: #1d4ed8; font-weight: 600; }
@media (prefers-reduced-motion: reduce) { .plsqled-object-row { transition: none; } }

.plsqled-object-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.plsqled-status-dot {
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.plsqled-status-dot.valid { background: #22c55e; }
.plsqled-status-dot.invalid { background: #ef4444; }

.plsqled-list-status {
  padding: 16px 10px;
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
}
.plsqled-list-status.error { color: #b91c1c; }

/* Main panel */
.plsqled-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

/* 위 두 줄(툴바 · 탭) 아래의 본문 — 편집기 · 호출문 · 결과 */
.plsqled-main-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 10px 14px;
  gap: 8px;
  overflow: hidden;
}

/* 1행 — SQL 편집의 편집기 툴바(App renderEditorToolbar)와 같은 여백·바탕·구분선. 줄 배치는 .editor-action-group(App.css) */
.plsqled-topbar {
  flex-shrink: 0;
  padding: 4px 8px 4px 6px;
  background: var(--color-bg, #fff);
  border-bottom: 1px solid var(--color-border, #e0e0e0);
}
.plsqled-topbar .editor-action-btn:disabled { opacity: 0.45; cursor: not-allowed; }

/* 2행 — 탭 줄(App renderFileTabsRow 와 같은 .file-tabs-container) */
.plsqled-filetabs-row {
  flex-shrink: 0;
  border-bottom: 1px solid var(--color-border, #e0e0e0);
}

/* 제목줄의 지금 편집 대상 — 길면 말줄임(전체는 title) */
.plsqled-current-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #333;
  font-family: var(--font-mono);
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.plsqled-current-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.plsqled-dirty-badge {
  font-size: 10.5px;
  font-weight: 600;
  color: #b45309;
  background: #fef3c7;
  border-radius: 4px;
  padding: 1px 6px;
  font-family: var(--font-ui);
}


/* SQLEditor(CodeMirror) 재사용 — 메인 SQL 편집기와 완전히 같은 컴포넌트/단축키/하이라이팅 */
.plsqled-editor-wrap {
  flex: 1 1 auto;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden;
}
.plsqled-editor-wrap:focus-within { border-color: var(--color-accent, #3b82f6); }

.plsqled-editor-placeholder {
  flex: 1 1 auto;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d1d5db;
  border-radius: 4px;
  color: #9ca3af;
  font-size: 12.5px;
  background: #fafbfc;
  text-align: center;
  padding: 16px;
}

/* 패키지 서브프로그램 개요(outline) — 클릭 시 편집기 내 해당 줄로 점프 */
.plsqled-outline-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  padding: 5px 2px;
  animation: plsqled-fade-swap 160ms ease-out;
}
@media (prefers-reduced-motion: reduce) { .plsqled-outline-bar { animation: none; } }

.plsqled-outline-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.03em;
  margin-right: 2px;
}

.plsqled-outline-chip {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 999px;
  padding: 2px 9px;
  font-size: 11px;
  font-family: var(--font-mono);
  color: #374151;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.plsqled-outline-chip:hover { background: #f3f4f6; }
.plsqled-outline-chip.function { border-color: #93c5fd; color: #1d4ed8; }
.plsqled-outline-chip.procedure { border-color: #d1d5db; }
@media (prefers-reduced-motion: reduce) { .plsqled-outline-chip { transition: none; } }

.plsqled-testcall {
  flex-shrink: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  animation: plsqled-fade-swap 160ms ease-out;
}
@keyframes plsqled-fade-swap {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) { .plsqled-testcall { animation: none; } }

.plsqled-testcall-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
  font-size: 11.5px;
  color: #6b7280;
}
/* 접혀 있으면 머리줄만 남는다 — 아래 테두리가 겹쳐 두 줄로 보이지 않게 */
.plsqled-testcall.collapsed .plsqled-testcall-header { border-bottom: none; }

/* 머리줄 전체가 접기 단추다 — 작은 화살표만 누르게 하면 맞히기 어렵다 */
.plsqled-testcall-toggle {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.plsqled-testcall-chevron { flex-shrink: 0; transition: transform 160ms ease-out; }
.plsqled-testcall.open .plsqled-testcall-chevron { transform: rotate(90deg); }
/* 접혀 있어도 실행(F5)은 이 호출문으로 돈다 — 무엇이 돌지 한 줄로 보여 준다 */
.plsqled-testcall-peek {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-mono);
  font-size: 11px;
  color: #374151;
}
.plsqled-testcall.open .plsqled-testcall-editor-wrap { animation: plsqled-fade-swap 160ms ease-out; }
@media (prefers-reduced-motion: reduce) {
  .plsqled-testcall-chevron { transition: none; }
  .plsqled-testcall.open .plsqled-testcall-editor-wrap { animation: none; }
}

.plsqled-sidebar-title {
  flex: 1 1;
  font-size: 11.5px;
  font-weight: 600;
  color: #6b7280;
}

/* 바인드 변수(파라미터) 입력 폼 — IN/IN OUT 값을 입력해 "값 적용"으로 호출문에 반영 */
.plsqled-testcall-params {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
  padding: 8px 10px;
  background: #fbfbfc;
  border-bottom: 1px solid #eee;
  animation: plsqled-fade-swap 160ms ease-out;
}
@media (prefers-reduced-motion: reduce) { .plsqled-testcall-params { animation: none; } }

.plsqled-testcall-param {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 120px;
}
.plsqled-testcall-param-name {
  font-size: 10.5px;
  font-weight: 600;
  color: #6b7280;
  font-family: var(--font-mono);
}
.plsqled-testcall-param-name em {
  font-style: normal;
  font-weight: 500;
  color: #9ca3af;
  margin-left: 3px;
}
.plsqled-testcall-param-input {
  padding: 3px 6px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  font-family: var(--font-mono);
}
.plsqled-testcall-param-input:disabled { background: #f3f4f6; color: #9ca3af; }
.plsqled-testcall-param-input:focus { outline: none; border-color: var(--color-accent, #3b82f6); }

.plsqled-testcall-apply { align-self: flex-end; }

.plsqled-testcall-editor-wrap {
  height: 110px;
  min-height: 70px;
  display: flex;
  flex-direction: column;
  /* .cm-editor 가 자체 테두리를 그리지 않으므로 여기서 긋는다 (.plsqled-editor-wrap 과 동일). */
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden;
}
/* SQLEditor 내부 CodeMirror는 전역(App.css)에서 min-height:200px를 강제하므로,
   이 컴팩트한 테스트 호출문 박스에서는 더 높은 detail specificity로 덮어쓴다. */
.plsqled-testcall-editor-wrap .codemirror-editor-area .cm-editor {
  min-height: 70px !important;
  height: 100% !important;
}

/* 위(편집)·아래(결과) 분할 — VerticalSplit 의 뿌리는 position:absolute 라 이 그릇이 자리를 잡는다(2026-11-04) */
.plsqled-split-host {
  flex: 1 1 auto;
  position: relative;
  min-height: 0;
}
.plsqled-upper {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  padding-bottom: 6px;
}
/* 분할 안에서는 편집기가 위 칸을 채운다 — 큰 최소 높이를 두면 막대를 올릴 때 넘친다 */
.plsqled-upper .plsqled-editor-wrap { min-height: 60px; }
.plsqled-split-host .Pane2 { padding-top: 6px; }

/* Results */
.plsqled-results {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
}

.plsqled-result-tabs {
  display: flex;
  background: #f0f2f5;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.plsqled-result-tab {
  padding: 7px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #555;
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 150ms ease, border-color 150ms ease;
}
.plsqled-result-tab:hover { color: #333; }
.plsqled-results.collapsed .plsqled-result-tabs { border-bottom: none; }
.plsqled-results.collapsed .plsqled-result-tab.active { background: transparent; border-bottom-color: transparent; }
/* 접기/펴기 — 탭 줄 오른쪽 끝 */
.plsqled-result-collapse {
  margin-left: auto;
  display: inline-flex; align-items: center; justify-content: center;
  width: 30px;
  border: none;
  background: transparent;
  color: #555;
  cursor: pointer;
  transition: color 150ms ease, background-color 150ms ease;
}
.plsqled-result-collapse:hover { color: #111; background: rgba(0, 0, 0, 0.05); }
/* 덮어쓰기 충돌의 단추 줄 — 결과 칸 맨 위에 고정(아래 본문만 스크롤) */
.plsqled-conflict-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  padding: 6px 10px;
  border-bottom: 1px solid #fbbf24;
  background: #fffbeb;
  animation: plsqled-fade-swap 160ms ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .plsqled-result-collapse { transition: none; }
  .plsqled-conflict-bar { animation: none; }
}
.plsqled-result-tab.active {
  color: var(--color-accent, #3b82f6);
  border-bottom-color: var(--color-accent, #3b82f6);
  background: #fff;
}
@media (prefers-reduced-motion: reduce) { .plsqled-result-tab { transition: none; } }

.plsqled-badge {
  font-size: 10px;
  font-weight: 700;
  background: #e5e7eb;
  color: #374151;
  border-radius: 999px;
  padding: 1px 6px;
  min-width: 14px;
  text-align: center;
}
.plsqled-badge.error { background: #fee2e2; color: #991b1b; }

.plsqled-result-body {
  flex: 1 1;
  overflow: auto;
  padding: 8px 10px;
  animation: plsqled-fade-swap 140ms ease-out;
}
@media (prefers-reduced-motion: reduce) { .plsqled-result-body { animation: none; } }

.plsqled-result-status { font-size: 12px; color: #9ca3af; padding: 8px 2px; }

.plsqled-result-error {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px 10px;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 4px;
  font-size: 12px;
  color: #991b1b;
  white-space: pre-wrap;
}

.plsqled-result-success {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  background: #dcfce7;
  border: 1px solid #86efac;
  border-radius: 4px;
  font-size: 12px;
  color: #166534;
}

.plsqled-result-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #166534;
  margin-bottom: 6px;
}

.plsqled-output-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 4px;
}

.plsqled-output {
  margin: 0;
  padding: 8px 10px;
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 4px;
  font-family: var(--font-mono);
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.plsqled-error-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  font-family: var(--font-mono);
}
.plsqled-error-table th {
  text-align: left;
  padding: 4px 8px;
  background: #f8f9fa;
  border-bottom: 2px solid #d0d5db;
  color: #333;
  position: sticky;
  top: 0;
}
.plsqled-error-table td {
  padding: 4px 8px;
  border-bottom: 1px solid #eee;
  color: #374151;
  vertical-align: top;
}

/* REF CURSOR 결과셋 그리드 — 실행 결과 탭 안에 표시 */
.plsqled-cursor-results { margin-top: 10px; display: flex; flex-direction: column; gap: 10px; }
.plsqled-cursor-result { border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden; }
.plsqled-cursor-result-title {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  background: #f0f2f5;
  font-size: 11px;
  font-weight: 600;
  color: #555;
}
.plsqled-cursor-result-grid-wrap { max-height: 220px; overflow: auto; }
.plsqled-cursor-result-grid { width: 100%; border-collapse: collapse; font-size: 11.5px; font-family: var(--font-mono); }
.plsqled-cursor-result-grid th {
  text-align: left;
  padding: 4px 8px;
  background: #fafbfc;
  border-bottom: 2px solid #d0d5db;
  color: #333;
  position: sticky;
  top: 0;
}
.plsqled-cursor-result-grid td { padding: 3px 8px; border-bottom: 1px solid #eee; color: #374151; white-space: nowrap; }

/* 의존성 트리 — 참조/피참조 2열 */
.plsqled-deps { display: flex; gap: 14px; }
.plsqled-deps-col { flex: 1 1; min-width: 0; }
.plsqled-deps-col-title { font-size: 11px; font-weight: 700; color: #6b7280; margin-bottom: 6px; }
.plsqled-deps-list { list-style: none; margin: 0; padding: 0; font-size: 12px; font-family: var(--font-mono); }
.plsqled-deps-list li { padding: 3px 0; color: #374151; overflow-wrap: anywhere; }
.plsqled-deps-type {
  display: inline-block;
  min-width: 62px;
  margin-right: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 3px;
  padding: 1px 5px;
  text-align: center;
}
.plsqled-deps-empty { color: #9ca3af; font-family: var(--font-ui); }

/* 로컬 편집 히스토리 패널 */
.plsqled-history-panel {
  flex-shrink: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 10px;
  max-height: 160px;
  overflow-y: auto;
  animation: plsqled-fade-swap 160ms ease-out;
}
@media (prefers-reduced-motion: reduce) { .plsqled-history-panel { animation: none; } }
.plsqled-history-panel-title { font-size: 10.5px; font-weight: 700; color: #9ca3af; margin-bottom: 6px; }
.plsqled-history-list { list-style: none; margin: 0; padding: 0; }
.plsqled-history-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 4px 6px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  border-radius: 4px;
  font-size: 11.5px;
  color: #374151;
}
.plsqled-history-item:hover { background: #f3f4f6; }
.plsqled-history-item-time { font-family: var(--font-mono); }
.plsqled-history-item-len { color: #9ca3af; }
.plsqled-history-item-note { margin-left: auto; font-size: 10.5px; color: #16a34a; }
.plsqled-btn-secondary.active { background: #eff6ff; border-color: #93c5fd; color: #1d4ed8; }

/* Buttons (shared) */
.plsqled-btn-primary,
.plsqled-btn-secondary {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.plsqled-btn-primary {
  background: var(--color-accent, #3b82f6);
  color: white;
  border-color: var(--color-accent, #3b82f6);
}
.plsqled-btn-primary:hover:not(:disabled) { background: var(--color-accent-hover, #2563eb); }
.plsqled-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }

.plsqled-btn-secondary {
  background: white;
  color: #555;
  border-color: #d1d5db;
}
.plsqled-btn-secondary:hover:not(:disabled) { background: #f3f4f6; color: #333; }
.plsqled-btn-secondary:disabled { opacity: 0.5; cursor: not-allowed; }

.plsqled-spin { animation: plsqled-spin 1s linear infinite; }
@keyframes plsqled-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .plsqled-spin { animation: none; } }

/* Footer */
.plsqled-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid #e0e0e0;
  background: #fafbfc;
  flex-shrink: 0;
}
.plsqled-footer-note { font-size: 11px; color: #888; }

/* ===================== Dark mode ===================== */
[data-theme="dark"] .plsqled-modal { background: var(--color-bg-tertiary); color: var(--color-text); }
[data-theme="dark"] .plsqled-header { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }
[data-theme="dark"] .plsqled-header h2 { color: var(--color-text); }
[data-theme="dark"] .plsqled-close { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-close:hover { color: var(--color-text); }
[data-theme="dark"] .plsqled-select,
[data-theme="dark"] .plsqled-schema-input { background: var(--color-input-bg); border-color: var(--color-input-border); color: var(--color-text); }
[data-theme="dark"] .plsqled-schema-label { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-empty-state { color: var(--color-text-muted); }

[data-theme="dark"] .plsqled-sidebar { background: var(--color-bg-secondary); border-right-color: var(--color-border); }
[data-theme="dark"] .plsqled-sidebar-toolbar { border-bottom-color: var(--color-border); }
[data-theme="dark"] .plsqled-icon-btn { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }
[data-theme="dark"] .plsqled-icon-btn:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }
[data-theme="dark"] .plsqled-search { border-bottom-color: var(--color-border); color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-search input { color: var(--color-text); }
[data-theme="dark"] .plsqled-object-group-label { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-object-row { color: var(--color-text-secondary); }
[data-theme="dark"] .plsqled-object-row:hover { background: var(--color-hover); }
[data-theme="dark"] .plsqled-object-row.active { background: rgba(59, 130, 246, 0.15); color: var(--color-accent-fg); }
[data-theme="dark"] .plsqled-list-status { color: var(--color-text-muted); }

[data-theme="dark"] .plsqled-current-label { color: var(--color-text); }
[data-theme="dark"] .plsqled-editor-wrap,
[data-theme="dark"] .plsqled-testcall-editor-wrap { border-color: var(--color-input-border); }
[data-theme="dark"] .plsqled-editor-placeholder { background: var(--color-bg-secondary); border-color: var(--color-border); color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-outline-label { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-outline-chip { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }
[data-theme="dark"] .plsqled-outline-chip:hover { background: var(--color-hover); }
[data-theme="dark"] .plsqled-outline-chip.function { border-color: var(--color-accent-fg); color: var(--color-accent-fg); }
[data-theme="dark"] .plsqled-recompile-btn { border-color: #b45309; color: #fbbf24; }
[data-theme="dark"] .plsqled-recompile-btn:hover:not(:disabled) { background: var(--color-hover); }
[data-theme="dark"] .plsqled-bulk-result { background: rgba(34, 197, 94, 0.12); border-color: rgba(34, 197, 94, 0.4); color: #86efac; }
[data-theme="dark"] .plsqled-bulk-result.warn { background: rgba(251, 191, 36, 0.12); border-color: rgba(251, 191, 36, 0.4); color: #fbbf24; }
[data-theme="dark"] .plsqled-testcall { border-color: var(--color-border); }
[data-theme="dark"] .plsqled-testcall-header { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-testcall-params { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }
[data-theme="dark"] .plsqled-testcall-param-name { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-testcall-param-input { background: var(--color-input-bg); border-color: var(--color-input-border); color: var(--color-text); }

[data-theme="dark"] .plsqled-results { border-color: var(--color-border); }
[data-theme="dark"] .plsqled-result-tabs { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }
[data-theme="dark"] .plsqled-result-tab { color: var(--color-text-secondary); }
[data-theme="dark"] .plsqled-result-tab.active { background: var(--color-bg-tertiary); color: var(--color-accent-fg); }
[data-theme="dark"] .plsqled-result-status { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-error-table th { background: var(--color-bg-secondary); color: var(--color-text); border-bottom-color: var(--color-border); }
[data-theme="dark"] .plsqled-error-table td { color: var(--color-text); border-bottom-color: var(--color-border); }

[data-theme="dark"] .plsqled-cursor-result { border-color: var(--color-border); }
[data-theme="dark"] .plsqled-cursor-result-title { background: var(--color-bg-secondary); color: var(--color-text-secondary); }
[data-theme="dark"] .plsqled-cursor-result-grid th { background: var(--color-bg-secondary); color: var(--color-text); border-bottom-color: var(--color-border); }
[data-theme="dark"] .plsqled-cursor-result-grid td { color: var(--color-text); border-bottom-color: var(--color-border); }

[data-theme="dark"] .plsqled-deps-col-title { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-deps-list li { color: var(--color-text-secondary); }
[data-theme="dark"] .plsqled-deps-type { background: var(--color-btn-bg); color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-deps-empty { color: var(--color-text-muted); }

[data-theme="dark"] .plsqled-history-panel { border-color: var(--color-border); }
[data-theme="dark"] .plsqled-history-panel-title { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-history-item { color: var(--color-text-secondary); }
[data-theme="dark"] .plsqled-history-item:hover { background: var(--color-hover); }
[data-theme="dark"] .plsqled-history-item-len { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-btn-secondary.active { background: rgba(59, 130, 246, 0.15); border-color: var(--color-accent-fg); color: var(--color-accent-fg); }

[data-theme="dark"] .plsqled-btn-secondary { background: var(--color-btn-bg); color: var(--color-text); border-color: var(--color-btn-border); }
/* color 를 빠뜨리면 밝은 모드의 \`color: #333\` 이 그대로 남아 어두운 배경에 검은 글자가 된다 */
[data-theme="dark"] .plsqled-btn-secondary:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }
[data-theme="dark"] .plsqled-footer { background: var(--color-bg-secondary); border-top-color: var(--color-border); }
[data-theme="dark"] .plsqled-footer-note { color: var(--color-text-muted); }

/* 테스트 호출 접기(2026-09-28) — 다크모드. color 를 함께 줘야 밝은 모드 값이 남지 않는다 */
[data-theme="dark"] .plsqled-testcall-peek { color: var(--color-text); }
[data-theme="dark"] .plsqled-testcall-toggle:hover { color: var(--color-text); }
[data-theme="dark"] .plsqled-sidebar-title { color: var(--color-text-muted); }

/* ── 덮어쓰기 충돌 (2026-09-29) ───────────────────────────────
   연 뒤에 DB 가 바뀌었거나, 열지 않은 기존 객체를 덮으려 할 때 컴파일 결과 탭에 뜬다. */
.plsqled-conflict {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid #fbbf24;
  border-radius: 6px;
  background: #fffbeb;
  animation: plsqled-fade-swap 160ms ease-out;
}
.plsqled-conflict-head { display: flex; align-items: center; gap: 6px; color: #92400e; font-size: 12.5px; }
.plsqled-conflict-msg { font-size: 12px; line-height: 1.55; color: #374151; }
.plsqled-conflict-legend { font-family: var(--font-mono); font-size: 11px; color: #6b7280; }
.plsqled-conflict-diff {
  margin: 0;
  max-height: 220px;
  overflow: auto;
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #fff;
  font-family: var(--font-mono);
  font-size: 11.5px;
  line-height: 1.5;
  white-space: pre;
}
.plsqled-diff-same { color: #6b7280; }
.plsqled-diff-del  { color: #991b1b; background: #fee2e2; }
.plsqled-diff-add  { color: #166534; background: #dcfce7; }
.plsqled-diff-gap  { color: #9ca3af; font-style: italic; }
.plsqled-conflict-note { display: flex; align-items: center; gap: 5px; font-size: 11px; color: #6b7280; }
.plsqled-conflict-actions { display: flex; justify-content: flex-end; gap: 6px; }

/* 되돌리기 어려운 동작(덮어쓰기)은 붉게 — 다른 버튼과 모양이 같으면 누르기 전에 멈칫하지 않는다 */
.plsqled-btn-danger {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 4px 12px;
  border: 1px solid #dc2626;
  border-radius: 4px;
  background: #dc2626;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease;
}
.plsqled-btn-danger:hover:not(:disabled) { background: #b91c1c; border-color: #b91c1c; color: #fff; }

/* 히스토리의 「덮어쓰기 전 원본」 표시 — 컴파일 스냅샷과 구분이 되어야 찾아 되돌린다 */
.plsqled-history-item-kind {
  padding: 0 6px;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 10px;
  font-weight: 600;
}

@media (prefers-reduced-motion: reduce) {
  .plsqled-conflict { animation: none; }
  .plsqled-btn-danger { transition: none; }
}

/* 다크모드 — color 를 함께 줘야 밝은 모드 값이 어두운 배경에 남지 않는다 */
[data-theme="dark"] .plsqled-conflict { background: rgba(180, 83, 9, 0.14); border-color: #b45309; }
[data-theme="dark"] .plsqled-conflict-head { color: #fcd34d; }
[data-theme="dark"] .plsqled-conflict-msg { color: var(--color-text); }
[data-theme="dark"] .plsqled-conflict-legend,
[data-theme="dark"] .plsqled-conflict-note { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-conflict-diff { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .plsqled-diff-same { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-diff-del  { color: #fca5a5; background: rgba(220, 38, 38, 0.18); }
[data-theme="dark"] .plsqled-diff-add  { color: #86efac; background: rgba(22, 163, 74, 0.18); }
[data-theme="dark"] .plsqled-diff-gap  { color: var(--color-text-muted); }
[data-theme="dark"] .plsqled-history-item-kind { background: #78350f; color: #fcd34d; }

/* ── 실시간 점검 (2026-10-02) — 탭 줄은 2026-11-02 부터 SQL 편집과 같은 .file-tabs-container(위 .plsqled-filetabs-row) ── */

.plsqled-badge.warn { background: #f59e0b; color: #fff; }
.plsqled-lint-table tbody tr { cursor: pointer; }
.plsqled-lint-table tbody tr:hover td { background: rgba(59, 130, 246, 0.06); }
.plsqled-lint-sev { display: inline-block; font-size: 10px; font-weight: 700; padding: 0 6px; margin-right: 6px; border-radius: 8px; }
.plsqled-lint-error .plsqled-lint-sev { background: #fee2e2; color: #b91c1c; }
.plsqled-lint-warning .plsqled-lint-sev { background: #fef3c7; color: #92400e; }

[data-theme="dark"] .plsqled-topbar { background: var(--color-bg); border-bottom-color: var(--color-border); }
[data-theme="dark"] .plsqled-filetabs-row { border-bottom-color: var(--color-border); }
[data-theme="dark"] .plsqled-lint-error .plsqled-lint-sev { background: rgba(185, 28, 28, 0.2); color: #fca5a5; }
[data-theme="dark"] .plsqled-lint-warning .plsqled-lint-sev { background: rgba(217, 119, 6, 0.2); color: #fcd34d; }

[data-theme="dark"] .plsqled-result-collapse { color: var(--color-text-secondary); }
[data-theme="dark"] .plsqled-result-collapse:hover { color: var(--color-text); background: var(--color-hover); }
[data-theme="dark"] .plsqled-conflict-bar { background: rgba(180, 83, 9, 0.14); border-bottom-color: #b45309; }
[data-theme="dark"] .plsqled-conflict-bar .plsqled-conflict-head { color: #fcd34d; }
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/PlsqlEditorModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,iBAAiB;EACjB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA,uBAAuB,WAAW,EAAE;;AAEpC,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,qBAAqB,SAAO,EAAE,uBAAuB,EAAE;;AAEvD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA,yCAAyC,mBAAmB,EAAE,WAAW,EAAE;AAC3E,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE,yBAAyB,QAAQ,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC1E,8CAA8C,mBAAmB,EAAE;AACnE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,8BAA8B,eAAe,EAAE,gBAAgB,EAAE,6BAA6B,EAAE;;AAEhG;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,2CAA2C;AAC7C;AACA,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACxF,4BAA4B,eAAe,EAAE,kBAAkB,EAAE;AACjE,+BAA+B,gBAAgB,EAAE;AACjD,0CAA0C,uBAAuB,eAAe,EAAE,EAAE;;AAEpF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uCAAuC;AACzC;AACA,4BAA4B,mBAAmB,EAAE;AACjD,6BAA6B,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACpF,0CAA0C,sBAAsB,gBAAgB,EAAE,EAAE;;AAEpF;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA,4BAA4B,mBAAmB,EAAE;AACjD,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,6BAA6B,cAAc,EAAE;;AAE7C,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,oGAAoG;AACpG;EACE,cAAc;EACd,wBAAwB;EACxB,iCAAiC;EACjC,qDAAqD;AACvD;AACA,8CAA8C,aAAa,EAAE,mBAAmB,EAAE;;AAElF,8DAA8D;AAC9D;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;;AAGA,kEAAkE;AAClE;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,oCAAoC,0CAA0C,EAAE;;AAEhF;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;AAC7C;AACA,0CAA0C,uBAAuB,eAAe,EAAE,EAAE;;AAEpF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gEAAgE;AAClE;AACA,8BAA8B,mBAAmB,EAAE;AACnD,iCAAiC,qBAAqB,EAAE,cAAc,EAAE;AACxE,kCAAkC,qBAAqB,EAAE;AACzD,0CAA0C,wBAAwB,gBAAgB,EAAE,EAAE;;AAEtF;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,0CAA0C,oBAAoB,eAAe,EAAE,EAAE;;AAEjF;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;AACA,6CAA6C;AAC7C,uDAAuD,mBAAmB,EAAE;;AAE5E,4CAA4C;AAC5C;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA,4BAA4B,cAAc,EAAE,oCAAoC,EAAE;AAClF,mDAAmD,wBAAwB,EAAE;AAC7E,kDAAkD;AAClD;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;AACA,uDAAuD,2CAA2C,EAAE;AACpG;EACE,4BAA4B,gBAAgB,EAAE;EAC9C,uDAAuD,eAAe,EAAE;AAC1E;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;AAC7C;AACA,0CAA0C,2BAA2B,eAAe,EAAE,EAAE;;AAExF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA,yCAAyC,mBAAmB,EAAE,cAAc,EAAE;AAC9E,sCAAsC,aAAa,EAAE,0CAA0C,EAAE;;AAEjG,0BAA0B,oBAAoB,EAAE;;AAEhD;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uEAAuE;EACvE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;wDACwD;AACxD;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,wFAAwF;AACxF;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;AACA,qDAAqD;AACrD,sCAAsC,gBAAgB,EAAE;AACxD,6BAA6B,gBAAgB,EAAE;;AAE/C,YAAY;AACZ;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;AACvD;AACA,4BAA4B,WAAW,EAAE;AACzC,kDAAkD,mBAAmB,EAAE;AACvE,wDAAwD,uBAAuB,EAAE,gCAAgC,EAAE;AACnH,sBAAsB;AACtB;EACE,iBAAiB;EACjB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,yDAAyD;AAC3D;AACA,iCAAiC,WAAW,EAAE,+BAA+B,EAAE;AAC/E,6CAA6C;AAC7C;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,2BAA2B,gBAAgB,EAAE;EAC7C,wBAAwB,eAAe,EAAE;AAC3C;AACA;EACE,mCAAmC;EACnC,iDAAiD;EACjD,gBAAgB;AAClB;AACA,0CAA0C,sBAAsB,gBAAgB,EAAE,EAAE;;AAEpF;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D;EACE,SAAO;EACP,cAAc;EACd,iBAAiB;EACjB,2CAA2C;AAC7C;AACA,0CAA0C,uBAAuB,eAAe,EAAE,EAAE;;AAEpF,yBAAyB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAE5E;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC,0BAA0B,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC9F,yBAAyB,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC1F;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA,mCAAmC,iBAAiB,EAAE,cAAc,EAAE;AACtE,8BAA8B,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE;AACxH;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,MAAM;AACR;AACA,iCAAiC,gBAAgB,EAAE,6BAA6B,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAEvH,uBAAuB;AACvB,gBAAgB,aAAa,EAAE,SAAS,EAAE;AAC1C,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACjG,qBAAqB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,eAAe,EAAE,6BAA6B,EAAE;AAC9G,wBAAwB,cAAc,EAAE,cAAc,EAAE,uBAAuB,EAAE;AACjF;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,sBAAsB,cAAc,EAAE,2BAA2B,EAAE;;AAEnE,kBAAkB;AAClB;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA,0CAA0C,yBAAyB,eAAe,EAAE,EAAE;AACtF,+BAA+B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACxG,wBAAwB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA,8BAA8B,mBAAmB,EAAE;AACnD,6BAA6B,6BAA6B,EAAE;AAC5D,4BAA4B,cAAc,EAAE;AAC5C,6BAA6B,iBAAiB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACnF,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAE5F,qBAAqB;AACrB;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,YAAY;EACZ,0CAA0C;AAC5C;AACA,4CAA4C,8CAA8C,EAAE;AAC5F,gCAAgC,YAAY,EAAE,mBAAmB,EAAE;;AAEnE;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;AACA,8CAA8C,mBAAmB,EAAE,WAAW,EAAE;AAChF,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;;AAErE,gBAAgB,0CAA0C,EAAE;AAC5D,0BAA0B,OAAO,uBAAuB,EAAE,EAAE,KAAK,yBAAyB,EAAE,EAAE;AAC9F,0CAA0C,gBAAgB,eAAe,EAAE,EAAE;;AAE7E,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;AACA,uBAAuB,eAAe,EAAE,WAAW,EAAE;;AAErD,0DAA0D;AAC1D,qCAAqC,oCAAoC,EAAE,wBAAwB,EAAE;AACrG,sCAAsC,qCAAqC,EAAE,wCAAwC,EAAE;AACvH,yCAAyC,wBAAwB,EAAE;AACnE,qCAAqC,8BAA8B,EAAE;AACrE,2CAA2C,wBAAwB,EAAE;AACrE;4CAC4C,iCAAiC,EAAE,uCAAuC,EAAE,wBAAwB,EAAE;AAClJ,4CAA4C,8BAA8B,EAAE;AAC5E,2CAA2C,8BAA8B,EAAE;;AAE3E,uCAAuC,qCAAqC,EAAE,uCAAuC,EAAE;AACvH,+CAA+C,wCAAwC,EAAE;AACzF,wCAAwC,+BAA+B,EAAE,qCAAqC,EAAE,kCAAkC,EAAE;AACpJ,6DAA6D,8BAA8B,EAAE,wBAAwB,EAAE;AACvH,sCAAsC,wCAAwC,EAAE,8BAA8B,EAAE;AAChH,4CAA4C,wBAAwB,EAAE;AACtE,kDAAkD,8BAA8B,EAAE;AAClF,0CAA0C,kCAAkC,EAAE;AAC9E,gDAAgD,8BAA8B,EAAE;AAChF,iDAAiD,oCAAoC,EAAE,6BAA6B,EAAE;AACtH,2CAA2C,8BAA8B,EAAE;;AAE3E,6CAA6C,wBAAwB,EAAE;AACvE;oDACoD,uCAAuC,EAAE;AAC7F,kDAAkD,qCAAqC,EAAE,iCAAiC,EAAE,8BAA8B,EAAE;AAC5J,6CAA6C,8BAA8B,EAAE;AAC7E,4CAA4C,+BAA+B,EAAE,qCAAqC,EAAE,kCAAkC,EAAE;AACxJ,kDAAkD,8BAA8B,EAAE;AAClF,qDAAqD,oCAAoC,EAAE,6BAA6B,EAAE;AAC1H,6CAA6C,qBAAqB,EAAE,cAAc,EAAE;AACpF,kEAAkE,8BAA8B,EAAE;AAClG,2CAA2C,mCAAmC,EAAE,oCAAoC,EAAE,cAAc,EAAE;AACtI,gDAAgD,oCAAoC,EAAE,qCAAqC,EAAE,cAAc,EAAE;AAC7I,wCAAwC,iCAAiC,EAAE;AAC3E,+CAA+C,qCAAqC,EAAE,wCAAwC,EAAE,8BAA8B,EAAE;AAChK,+CAA+C,qCAAqC,EAAE,wCAAwC,EAAE;AAChI,mDAAmD,8BAA8B,EAAE;AACnF,oDAAoD,iCAAiC,EAAE,uCAAuC,EAAE,wBAAwB,EAAE;;AAE1J,uCAAuC,iCAAiC,EAAE;AAC1E,2CAA2C,qCAAqC,EAAE,wCAAwC,EAAE;AAC5H,0CAA0C,kCAAkC,EAAE;AAC9E,iDAAiD,oCAAoC,EAAE,6BAA6B,EAAE;AACtH,6CAA6C,8BAA8B,EAAE;AAC7E,8CAA8C,qCAAqC,EAAE,wBAAwB,EAAE,wCAAwC,EAAE;AACzJ,8CAA8C,wBAAwB,EAAE,wCAAwC,EAAE;;AAElH,6CAA6C,iCAAiC,EAAE;AAChF,mDAAmD,qCAAqC,EAAE,kCAAkC,EAAE;AAC9H,qDAAqD,qCAAqC,EAAE,wBAAwB,EAAE,wCAAwC,EAAE;AAChK,qDAAqD,wBAAwB,EAAE,wCAAwC,EAAE;;AAEzH,8CAA8C,8BAA8B,EAAE;AAC9E,4CAA4C,kCAAkC,EAAE;AAChF,yCAAyC,+BAA+B,EAAE,8BAA8B,EAAE;AAC1G,0CAA0C,8BAA8B,EAAE;;AAE1E,6CAA6C,iCAAiC,EAAE;AAChF,mDAAmD,8BAA8B,EAAE;AACnF,4CAA4C,kCAAkC,EAAE;AAChF,kDAAkD,8BAA8B,EAAE;AAClF,gDAAgD,8BAA8B,EAAE;AAChF,oDAAoD,oCAAoC,EAAE,oCAAoC,EAAE,6BAA6B,EAAE;;AAE/J,6CAA6C,+BAA+B,EAAE,wBAAwB,EAAE,qCAAqC,EAAE;AAC/I,iEAAiE;AACjE,kEAAkE,8BAA8B,EAAE,wBAAwB,EAAE;AAC5H,sCAAsC,qCAAqC,EAAE,qCAAqC,EAAE;AACpH,2CAA2C,8BAA8B,EAAE;;AAE3E,gEAAgE;AAChE,6CAA6C,wBAAwB,EAAE;AACvE,qDAAqD,wBAAwB,EAAE;AAC/E,6CAA6C,8BAA8B,EAAE;;AAE7E;wDACwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC1G,wBAAwB,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC5E,2BAA2B,6BAA6B,EAAE,eAAe,EAAE,cAAc,EAAE;AAC3F;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,cAAc,EAAE,mBAAmB,EAAE;AAC1D,qBAAqB,cAAc,EAAE,mBAAmB,EAAE;AAC1D,qBAAqB,cAAc,EAAE,kBAAkB,EAAE;AACzD,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,cAAc,EAAE;AACxG,4BAA4B,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE;;AAEhF,2DAA2D;AAC3D;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,0DAA0D;AAC5D;AACA,2CAA2C,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;;AAEpG,oDAAoD;AACpD;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB,eAAe,EAAE;EACrC,sBAAsB,gBAAgB,EAAE;AAC1C;;AAEA,iDAAiD;AACjD,wCAAwC,kCAAkC,EAAE,qBAAqB,EAAE;AACnG,6CAA6C,cAAc,EAAE;AAC7D,4CAA4C,wBAAwB,EAAE;AACtE;6CAC6C,8BAA8B,EAAE;AAC7E,6CAA6C,qCAAqC,EAAE,iCAAiC,EAAE;AACvH,yCAAyC,8BAA8B,EAAE;AACzE,yCAAyC,cAAc,EAAE,mCAAmC,EAAE;AAC9F,yCAAyC,cAAc,EAAE,mCAAmC,EAAE;AAC9F,yCAAyC,8BAA8B,EAAE;AACzE,iDAAiD,mBAAmB,EAAE,cAAc,EAAE;;AAEtF,4GAA4G;;AAE5G,sBAAsB,mBAAmB,EAAE,WAAW,EAAE;AACxD,+BAA+B,eAAe,EAAE;AAChD,wCAAwC,oCAAoC,EAAE;AAC9E,oBAAoB,qBAAqB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACrI,wCAAwC,mBAAmB,EAAE,cAAc,EAAE;AAC7E,0CAA0C,mBAAmB,EAAE,cAAc,EAAE;;AAE/E,sCAAsC,2BAA2B,EAAE,wCAAwC,EAAE;AAC7G,4CAA4C,wCAAwC,EAAE;AACtF,4DAA4D,kCAAkC,EAAE,cAAc,EAAE;AAChH,8DAA8D,kCAAkC,EAAE,cAAc,EAAE;;AAElH,+CAA+C,kCAAkC,EAAE;AACnF,qDAAqD,wBAAwB,EAAE,8BAA8B,EAAE;AAC/G,4CAA4C,kCAAkC,EAAE,4BAA4B,EAAE;AAC9G,mEAAmE,cAAc,EAAE","sourcesContent":[".plsqled-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n}\n\n.plsqled-modal {\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  width: 95%;\n  max-width: 1500px;\n  height: calc(90vh / var(--app-zoom, 1));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Header */\n.plsqled-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e0e0e0;\n  flex-shrink: 0;\n}\n\n.plsqled-header h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.plsqled-header-controls {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.plsqled-select {\n  padding: 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 12px;\n  background: white;\n  min-width: 160px;\n}\n\n.plsqled-schema-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  color: #6b7280;\n}\n\n.plsqled-schema-input {\n  width: 110px;\n  padding: 3px 6px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: var(--font-mono);\n  text-transform: uppercase;\n}\n\n.plsqled-close {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #999;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n}\n.plsqled-close:hover { color: #333; }\n\n/* Empty state (연결 없음) */\n.plsqled-empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n/* Body layout */\n.plsqled-body {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  min-height: 0;\n}\n\n/* Sidebar */\n.plsqled-sidebar {\n  width: 240px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #e0e0e0;\n  background: #fafbfc;\n}\n\n.plsqled-sidebar-toolbar {\n  display: flex;\n  gap: 6px;\n  padding: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n.plsqled-btn-block { flex: 1; justify-content: center; }\n\n.plsqled-icon-btn {\n  background: none;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  padding: 4px 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  color: #555;\n}\n.plsqled-icon-btn:hover:not(:disabled) { background: #f3f4f6; color: #333; }\n.plsqled-icon-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.plsqled-recompile-btn { gap: 4px; color: #b45309; border-color: #fbbf24; }\n.plsqled-recompile-btn:hover:not(:disabled) { background: #fffbeb; }\n.plsqled-recompile-count {\n  font-size: 10.5px;\n  font-weight: 700;\n  background: #fef3c7;\n  color: #92400e;\n  border-radius: 999px;\n  padding: 0 5px;\n  min-width: 14px;\n  text-align: center;\n}\n.plsqled-recompile-progress { font-size: 11px; font-weight: 600; font-family: var(--font-mono); }\n\n.plsqled-bulk-result {\n  margin: 0 8px 6px;\n  padding: 6px 8px;\n  border-radius: 4px;\n  font-size: 11.5px;\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  color: #166534;\n  animation: plsqled-fade-swap 160ms ease-out;\n}\n.plsqled-bulk-result.warn { background: #fffbeb; border-color: #fbbf24; color: #92400e; }\n.plsqled-bulk-result-list { margin: 4px 0 0; padding-left: 16px; }\n.plsqled-bulk-result-list li { line-height: 1.5; }\n@media (prefers-reduced-motion: reduce) { .plsqled-bulk-result { animation: none; } }\n\n.plsqled-search {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-bottom: 1px solid #eee;\n  color: #9ca3af;\n}\n.plsqled-search input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 12px;\n  background: transparent;\n  color: #374151;\n}\n\n.plsqled-object-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\n.plsqled-object-group-label {\n  padding: 6px 10px 3px;\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.03em;\n}\n\n.plsqled-object-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 5px 10px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 12.5px;\n  color: #374151;\n  transition: background-color 150ms ease;\n}\n.plsqled-object-row:hover { background: #f3f4f6; }\n.plsqled-object-row.active { background: #eff6ff; color: #1d4ed8; font-weight: 600; }\n@media (prefers-reduced-motion: reduce) { .plsqled-object-row { transition: none; } }\n\n.plsqled-object-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.plsqled-status-dot {\n  flex-shrink: 0;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n.plsqled-status-dot.valid { background: #22c55e; }\n.plsqled-status-dot.invalid { background: #ef4444; }\n\n.plsqled-list-status {\n  padding: 16px 10px;\n  text-align: center;\n  font-size: 12px;\n  color: #9ca3af;\n}\n.plsqled-list-status.error { color: #b91c1c; }\n\n/* Main panel */\n.plsqled-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* 위 두 줄(툴바 · 탭) 아래의 본문 — 편집기 · 호출문 · 결과 */\n.plsqled-main-body {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  padding: 10px 14px;\n  gap: 8px;\n  overflow: hidden;\n}\n\n/* 1행 — SQL 편집의 편집기 툴바(App renderEditorToolbar)와 같은 여백·바탕·구분선. 줄 배치는 .editor-action-group(App.css) */\n.plsqled-topbar {\n  flex-shrink: 0;\n  padding: 4px 8px 4px 6px;\n  background: var(--color-bg, #fff);\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\n}\n.plsqled-topbar .editor-action-btn:disabled { opacity: 0.45; cursor: not-allowed; }\n\n/* 2행 — 탭 줄(App renderFileTabsRow 와 같은 .file-tabs-container) */\n.plsqled-filetabs-row {\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\n}\n\n/* 제목줄의 지금 편집 대상 — 길면 말줄임(전체는 title) */\n.plsqled-current-label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #333;\n  font-family: var(--font-mono);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n.plsqled-current-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.plsqled-dirty-badge {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: #b45309;\n  background: #fef3c7;\n  border-radius: 4px;\n  padding: 1px 6px;\n  font-family: var(--font-ui);\n}\n\n\n/* SQLEditor(CodeMirror) 재사용 — 메인 SQL 편집기와 완전히 같은 컴포넌트/단축키/하이라이팅 */\n.plsqled-editor-wrap {\n  flex: 1 1 auto;\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.plsqled-editor-wrap:focus-within { border-color: var(--color-accent, #3b82f6); }\n\n.plsqled-editor-placeholder {\n  flex: 1 1 auto;\n  min-height: 160px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px dashed #d1d5db;\n  border-radius: 4px;\n  color: #9ca3af;\n  font-size: 12.5px;\n  background: #fafbfc;\n  text-align: center;\n  padding: 16px;\n}\n\n/* 패키지 서브프로그램 개요(outline) — 클릭 시 편집기 내 해당 줄로 점프 */\n.plsqled-outline-bar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 5px;\n  padding: 5px 2px;\n  animation: plsqled-fade-swap 160ms ease-out;\n}\n@media (prefers-reduced-motion: reduce) { .plsqled-outline-bar { animation: none; } }\n\n.plsqled-outline-label {\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.03em;\n  margin-right: 2px;\n}\n\n.plsqled-outline-chip {\n  border: 1px solid #d1d5db;\n  background: #fff;\n  border-radius: 999px;\n  padding: 2px 9px;\n  font-size: 11px;\n  font-family: var(--font-mono);\n  color: #374151;\n  cursor: pointer;\n  transition: background-color 150ms ease, border-color 150ms ease;\n}\n.plsqled-outline-chip:hover { background: #f3f4f6; }\n.plsqled-outline-chip.function { border-color: #93c5fd; color: #1d4ed8; }\n.plsqled-outline-chip.procedure { border-color: #d1d5db; }\n@media (prefers-reduced-motion: reduce) { .plsqled-outline-chip { transition: none; } }\n\n.plsqled-testcall {\n  flex-shrink: 0;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  overflow: hidden;\n  animation: plsqled-fade-swap 160ms ease-out;\n}\n@keyframes plsqled-fade-swap {\n  from { opacity: 0; transform: translateY(-3px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@media (prefers-reduced-motion: reduce) { .plsqled-testcall { animation: none; } }\n\n.plsqled-testcall-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #eee;\n  font-size: 11.5px;\n  color: #6b7280;\n}\n/* 접혀 있으면 머리줄만 남는다 — 아래 테두리가 겹쳐 두 줄로 보이지 않게 */\n.plsqled-testcall.collapsed .plsqled-testcall-header { border-bottom: none; }\n\n/* 머리줄 전체가 접기 단추다 — 작은 화살표만 누르게 하면 맞히기 어렵다 */\n.plsqled-testcall-toggle {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border: none;\n  background: none;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n.plsqled-testcall-chevron { flex-shrink: 0; transition: transform 160ms ease-out; }\n.plsqled-testcall.open .plsqled-testcall-chevron { transform: rotate(90deg); }\n/* 접혀 있어도 실행(F5)은 이 호출문으로 돈다 — 무엇이 돌지 한 줄로 보여 준다 */\n.plsqled-testcall-peek {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  color: #374151;\n}\n.plsqled-testcall.open .plsqled-testcall-editor-wrap { animation: plsqled-fade-swap 160ms ease-out; }\n@media (prefers-reduced-motion: reduce) {\n  .plsqled-testcall-chevron { transition: none; }\n  .plsqled-testcall.open .plsqled-testcall-editor-wrap { animation: none; }\n}\n\n.plsqled-sidebar-title {\n  flex: 1;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n/* 바인드 변수(파라미터) 입력 폼 — IN/IN OUT 값을 입력해 \"값 적용\"으로 호출문에 반영 */\n.plsqled-testcall-params {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 8px 10px;\n  background: #fbfbfc;\n  border-bottom: 1px solid #eee;\n  animation: plsqled-fade-swap 160ms ease-out;\n}\n@media (prefers-reduced-motion: reduce) { .plsqled-testcall-params { animation: none; } }\n\n.plsqled-testcall-param {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 120px;\n}\n.plsqled-testcall-param-name {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: #6b7280;\n  font-family: var(--font-mono);\n}\n.plsqled-testcall-param-name em {\n  font-style: normal;\n  font-weight: 500;\n  color: #9ca3af;\n  margin-left: 3px;\n}\n.plsqled-testcall-param-input {\n  padding: 3px 6px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: var(--font-mono);\n}\n.plsqled-testcall-param-input:disabled { background: #f3f4f6; color: #9ca3af; }\n.plsqled-testcall-param-input:focus { outline: none; border-color: var(--color-accent, #3b82f6); }\n\n.plsqled-testcall-apply { align-self: flex-end; }\n\n.plsqled-testcall-editor-wrap {\n  height: 110px;\n  min-height: 70px;\n  display: flex;\n  flex-direction: column;\n  /* .cm-editor 가 자체 테두리를 그리지 않으므로 여기서 긋는다 (.plsqled-editor-wrap 과 동일). */\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  overflow: hidden;\n}\n/* SQLEditor 내부 CodeMirror는 전역(App.css)에서 min-height:200px를 강제하므로,\n   이 컴팩트한 테스트 호출문 박스에서는 더 높은 detail specificity로 덮어쓴다. */\n.plsqled-testcall-editor-wrap .codemirror-editor-area .cm-editor {\n  min-height: 70px !important;\n  height: 100% !important;\n}\n\n/* 위(편집)·아래(결과) 분할 — VerticalSplit 의 뿌리는 position:absolute 라 이 그릇이 자리를 잡는다(2026-11-04) */\n.plsqled-split-host {\n  flex: 1 1 auto;\n  position: relative;\n  min-height: 0;\n}\n.plsqled-upper {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 0;\n  padding-bottom: 6px;\n}\n/* 분할 안에서는 편집기가 위 칸을 채운다 — 큰 최소 높이를 두면 막대를 올릴 때 넘친다 */\n.plsqled-upper .plsqled-editor-wrap { min-height: 60px; }\n.plsqled-split-host .Pane2 { padding-top: 6px; }\n\n/* Results */\n.plsqled-results {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.plsqled-result-tabs {\n  display: flex;\n  background: #f0f2f5;\n  border-bottom: 1px solid #e0e0e0;\n  flex-shrink: 0;\n}\n\n.plsqled-result-tab {\n  padding: 7px 14px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  color: #555;\n  border-bottom: 2px solid transparent;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: color 150ms ease, border-color 150ms ease;\n}\n.plsqled-result-tab:hover { color: #333; }\n.plsqled-results.collapsed .plsqled-result-tabs { border-bottom: none; }\n.plsqled-results.collapsed .plsqled-result-tab.active { background: transparent; border-bottom-color: transparent; }\n/* 접기/펴기 — 탭 줄 오른쪽 끝 */\n.plsqled-result-collapse {\n  margin-left: auto;\n  display: inline-flex; align-items: center; justify-content: center;\n  width: 30px;\n  border: none;\n  background: transparent;\n  color: #555;\n  cursor: pointer;\n  transition: color 150ms ease, background-color 150ms ease;\n}\n.plsqled-result-collapse:hover { color: #111; background: rgba(0, 0, 0, 0.05); }\n/* 덮어쓰기 충돌의 단추 줄 — 결과 칸 맨 위에 고정(아래 본문만 스크롤) */\n.plsqled-conflict-bar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 6px 10px;\n  border-bottom: 1px solid #fbbf24;\n  background: #fffbeb;\n  animation: plsqled-fade-swap 160ms ease-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .plsqled-result-collapse { transition: none; }\n  .plsqled-conflict-bar { animation: none; }\n}\n.plsqled-result-tab.active {\n  color: var(--color-accent, #3b82f6);\n  border-bottom-color: var(--color-accent, #3b82f6);\n  background: #fff;\n}\n@media (prefers-reduced-motion: reduce) { .plsqled-result-tab { transition: none; } }\n\n.plsqled-badge {\n  font-size: 10px;\n  font-weight: 700;\n  background: #e5e7eb;\n  color: #374151;\n  border-radius: 999px;\n  padding: 1px 6px;\n  min-width: 14px;\n  text-align: center;\n}\n.plsqled-badge.error { background: #fee2e2; color: #991b1b; }\n\n.plsqled-result-body {\n  flex: 1;\n  overflow: auto;\n  padding: 8px 10px;\n  animation: plsqled-fade-swap 140ms ease-out;\n}\n@media (prefers-reduced-motion: reduce) { .plsqled-result-body { animation: none; } }\n\n.plsqled-result-status { font-size: 12px; color: #9ca3af; padding: 8px 2px; }\n\n.plsqled-result-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 8px 10px;\n  background: #fee2e2;\n  border: 1px solid #fca5a5;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #991b1b;\n  white-space: pre-wrap;\n}\n\n.plsqled-result-success {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  background: #dcfce7;\n  border: 1px solid #86efac;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #166534;\n}\n\n.plsqled-result-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #166534;\n  margin-bottom: 6px;\n}\n\n.plsqled-output-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.plsqled-output {\n  margin: 0;\n  padding: 8px 10px;\n  background: #0f172a;\n  color: #e2e8f0;\n  border-radius: 4px;\n  font-family: var(--font-mono);\n  font-size: 12px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.plsqled-error-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  font-family: var(--font-mono);\n}\n.plsqled-error-table th {\n  text-align: left;\n  padding: 4px 8px;\n  background: #f8f9fa;\n  border-bottom: 2px solid #d0d5db;\n  color: #333;\n  position: sticky;\n  top: 0;\n}\n.plsqled-error-table td {\n  padding: 4px 8px;\n  border-bottom: 1px solid #eee;\n  color: #374151;\n  vertical-align: top;\n}\n\n/* REF CURSOR 결과셋 그리드 — 실행 결과 탭 안에 표시 */\n.plsqled-cursor-results { margin-top: 10px; display: flex; flex-direction: column; gap: 10px; }\n.plsqled-cursor-result { border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden; }\n.plsqled-cursor-result-title {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 8px;\n  background: #f0f2f5;\n  font-size: 11px;\n  font-weight: 600;\n  color: #555;\n}\n.plsqled-cursor-result-grid-wrap { max-height: 220px; overflow: auto; }\n.plsqled-cursor-result-grid { width: 100%; border-collapse: collapse; font-size: 11.5px; font-family: var(--font-mono); }\n.plsqled-cursor-result-grid th {\n  text-align: left;\n  padding: 4px 8px;\n  background: #fafbfc;\n  border-bottom: 2px solid #d0d5db;\n  color: #333;\n  position: sticky;\n  top: 0;\n}\n.plsqled-cursor-result-grid td { padding: 3px 8px; border-bottom: 1px solid #eee; color: #374151; white-space: nowrap; }\n\n/* 의존성 트리 — 참조/피참조 2열 */\n.plsqled-deps { display: flex; gap: 14px; }\n.plsqled-deps-col { flex: 1; min-width: 0; }\n.plsqled-deps-col-title { font-size: 11px; font-weight: 700; color: #6b7280; margin-bottom: 6px; }\n.plsqled-deps-list { list-style: none; margin: 0; padding: 0; font-size: 12px; font-family: var(--font-mono); }\n.plsqled-deps-list li { padding: 3px 0; color: #374151; overflow-wrap: anywhere; }\n.plsqled-deps-type {\n  display: inline-block;\n  min-width: 62px;\n  margin-right: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #6b7280;\n  background: #f3f4f6;\n  border-radius: 3px;\n  padding: 1px 5px;\n  text-align: center;\n}\n.plsqled-deps-empty { color: #9ca3af; font-family: var(--font-ui); }\n\n/* 로컬 편집 히스토리 패널 */\n.plsqled-history-panel {\n  flex-shrink: 0;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 8px 10px;\n  max-height: 160px;\n  overflow-y: auto;\n  animation: plsqled-fade-swap 160ms ease-out;\n}\n@media (prefers-reduced-motion: reduce) { .plsqled-history-panel { animation: none; } }\n.plsqled-history-panel-title { font-size: 10.5px; font-weight: 700; color: #9ca3af; margin-bottom: 6px; }\n.plsqled-history-list { list-style: none; margin: 0; padding: 0; }\n.plsqled-history-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 4px 6px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 11.5px;\n  color: #374151;\n}\n.plsqled-history-item:hover { background: #f3f4f6; }\n.plsqled-history-item-time { font-family: var(--font-mono); }\n.plsqled-history-item-len { color: #9ca3af; }\n.plsqled-history-item-note { margin-left: auto; font-size: 10.5px; color: #16a34a; }\n.plsqled-btn-secondary.active { background: #eff6ff; border-color: #93c5fd; color: #1d4ed8; }\n\n/* Buttons (shared) */\n.plsqled-btn-primary,\n.plsqled-btn-secondary {\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n.plsqled-btn-primary {\n  background: var(--color-accent, #3b82f6);\n  color: white;\n  border-color: var(--color-accent, #3b82f6);\n}\n.plsqled-btn-primary:hover:not(:disabled) { background: var(--color-accent-hover, #2563eb); }\n.plsqled-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.plsqled-btn-secondary {\n  background: white;\n  color: #555;\n  border-color: #d1d5db;\n}\n.plsqled-btn-secondary:hover:not(:disabled) { background: #f3f4f6; color: #333; }\n.plsqled-btn-secondary:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.plsqled-spin { animation: plsqled-spin 1s linear infinite; }\n@keyframes plsqled-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }\n@media (prefers-reduced-motion: reduce) { .plsqled-spin { animation: none; } }\n\n/* Footer */\n.plsqled-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  border-top: 1px solid #e0e0e0;\n  background: #fafbfc;\n  flex-shrink: 0;\n}\n.plsqled-footer-note { font-size: 11px; color: #888; }\n\n/* ===================== Dark mode ===================== */\n[data-theme=\"dark\"] .plsqled-modal { background: var(--color-bg-tertiary); color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-header { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-header h2 { color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-close { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-close:hover { color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-select,\n[data-theme=\"dark\"] .plsqled-schema-input { background: var(--color-input-bg); border-color: var(--color-input-border); color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-schema-label { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-empty-state { color: var(--color-text-muted); }\n\n[data-theme=\"dark\"] .plsqled-sidebar { background: var(--color-bg-secondary); border-right-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-sidebar-toolbar { border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-icon-btn { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .plsqled-icon-btn:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-search { border-bottom-color: var(--color-border); color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-search input { color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-object-group-label { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-object-row { color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .plsqled-object-row:hover { background: var(--color-hover); }\n[data-theme=\"dark\"] .plsqled-object-row.active { background: rgba(59, 130, 246, 0.15); color: var(--color-accent-fg); }\n[data-theme=\"dark\"] .plsqled-list-status { color: var(--color-text-muted); }\n\n[data-theme=\"dark\"] .plsqled-current-label { color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-editor-wrap,\n[data-theme=\"dark\"] .plsqled-testcall-editor-wrap { border-color: var(--color-input-border); }\n[data-theme=\"dark\"] .plsqled-editor-placeholder { background: var(--color-bg-secondary); border-color: var(--color-border); color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-outline-label { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-outline-chip { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .plsqled-outline-chip:hover { background: var(--color-hover); }\n[data-theme=\"dark\"] .plsqled-outline-chip.function { border-color: var(--color-accent-fg); color: var(--color-accent-fg); }\n[data-theme=\"dark\"] .plsqled-recompile-btn { border-color: #b45309; color: #fbbf24; }\n[data-theme=\"dark\"] .plsqled-recompile-btn:hover:not(:disabled) { background: var(--color-hover); }\n[data-theme=\"dark\"] .plsqled-bulk-result { background: rgba(34, 197, 94, 0.12); border-color: rgba(34, 197, 94, 0.4); color: #86efac; }\n[data-theme=\"dark\"] .plsqled-bulk-result.warn { background: rgba(251, 191, 36, 0.12); border-color: rgba(251, 191, 36, 0.4); color: #fbbf24; }\n[data-theme=\"dark\"] .plsqled-testcall { border-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-testcall-header { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-testcall-params { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-testcall-param-name { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-testcall-param-input { background: var(--color-input-bg); border-color: var(--color-input-border); color: var(--color-text); }\n\n[data-theme=\"dark\"] .plsqled-results { border-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-result-tabs { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-result-tab { color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .plsqled-result-tab.active { background: var(--color-bg-tertiary); color: var(--color-accent-fg); }\n[data-theme=\"dark\"] .plsqled-result-status { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-error-table th { background: var(--color-bg-secondary); color: var(--color-text); border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-error-table td { color: var(--color-text); border-bottom-color: var(--color-border); }\n\n[data-theme=\"dark\"] .plsqled-cursor-result { border-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-cursor-result-title { background: var(--color-bg-secondary); color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .plsqled-cursor-result-grid th { background: var(--color-bg-secondary); color: var(--color-text); border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-cursor-result-grid td { color: var(--color-text); border-bottom-color: var(--color-border); }\n\n[data-theme=\"dark\"] .plsqled-deps-col-title { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-deps-list li { color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .plsqled-deps-type { background: var(--color-btn-bg); color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-deps-empty { color: var(--color-text-muted); }\n\n[data-theme=\"dark\"] .plsqled-history-panel { border-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-history-panel-title { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-history-item { color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .plsqled-history-item:hover { background: var(--color-hover); }\n[data-theme=\"dark\"] .plsqled-history-item-len { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-btn-secondary.active { background: rgba(59, 130, 246, 0.15); border-color: var(--color-accent-fg); color: var(--color-accent-fg); }\n\n[data-theme=\"dark\"] .plsqled-btn-secondary { background: var(--color-btn-bg); color: var(--color-text); border-color: var(--color-btn-border); }\n/* color 를 빠뜨리면 밝은 모드의 `color: #333` 이 그대로 남아 어두운 배경에 검은 글자가 된다 */\n[data-theme=\"dark\"] .plsqled-btn-secondary:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-footer { background: var(--color-bg-secondary); border-top-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-footer-note { color: var(--color-text-muted); }\n\n/* 테스트 호출 접기(2026-09-28) — 다크모드. color 를 함께 줘야 밝은 모드 값이 남지 않는다 */\n[data-theme=\"dark\"] .plsqled-testcall-peek { color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-testcall-toggle:hover { color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-sidebar-title { color: var(--color-text-muted); }\n\n/* ── 덮어쓰기 충돌 (2026-09-29) ───────────────────────────────\n   연 뒤에 DB 가 바뀌었거나, 열지 않은 기존 객체를 덮으려 할 때 컴파일 결과 탭에 뜬다. */\n.plsqled-conflict {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 10px;\n  border: 1px solid #fbbf24;\n  border-radius: 6px;\n  background: #fffbeb;\n  animation: plsqled-fade-swap 160ms ease-out;\n}\n.plsqled-conflict-head { display: flex; align-items: center; gap: 6px; color: #92400e; font-size: 12.5px; }\n.plsqled-conflict-msg { font-size: 12px; line-height: 1.55; color: #374151; }\n.plsqled-conflict-legend { font-family: var(--font-mono); font-size: 11px; color: #6b7280; }\n.plsqled-conflict-diff {\n  margin: 0;\n  max-height: 220px;\n  overflow: auto;\n  padding: 6px 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  background: #fff;\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  line-height: 1.5;\n  white-space: pre;\n}\n.plsqled-diff-same { color: #6b7280; }\n.plsqled-diff-del  { color: #991b1b; background: #fee2e2; }\n.plsqled-diff-add  { color: #166534; background: #dcfce7; }\n.plsqled-diff-gap  { color: #9ca3af; font-style: italic; }\n.plsqled-conflict-note { display: flex; align-items: center; gap: 5px; font-size: 11px; color: #6b7280; }\n.plsqled-conflict-actions { display: flex; justify-content: flex-end; gap: 6px; }\n\n/* 되돌리기 어려운 동작(덮어쓰기)은 붉게 — 다른 버튼과 모양이 같으면 누르기 전에 멈칫하지 않는다 */\n.plsqled-btn-danger {\n  display: inline-flex; align-items: center; gap: 4px;\n  padding: 4px 12px;\n  border: 1px solid #dc2626;\n  border-radius: 4px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease;\n}\n.plsqled-btn-danger:hover:not(:disabled) { background: #b91c1c; border-color: #b91c1c; color: #fff; }\n\n/* 히스토리의 「덮어쓰기 전 원본」 표시 — 컴파일 스냅샷과 구분이 되어야 찾아 되돌린다 */\n.plsqled-history-item-kind {\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #fef3c7;\n  color: #92400e;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .plsqled-conflict { animation: none; }\n  .plsqled-btn-danger { transition: none; }\n}\n\n/* 다크모드 — color 를 함께 줘야 밝은 모드 값이 어두운 배경에 남지 않는다 */\n[data-theme=\"dark\"] .plsqled-conflict { background: rgba(180, 83, 9, 0.14); border-color: #b45309; }\n[data-theme=\"dark\"] .plsqled-conflict-head { color: #fcd34d; }\n[data-theme=\"dark\"] .plsqled-conflict-msg { color: var(--color-text); }\n[data-theme=\"dark\"] .plsqled-conflict-legend,\n[data-theme=\"dark\"] .plsqled-conflict-note { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-conflict-diff { background: var(--color-bg-secondary); border-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-diff-same { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-diff-del  { color: #fca5a5; background: rgba(220, 38, 38, 0.18); }\n[data-theme=\"dark\"] .plsqled-diff-add  { color: #86efac; background: rgba(22, 163, 74, 0.18); }\n[data-theme=\"dark\"] .plsqled-diff-gap  { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .plsqled-history-item-kind { background: #78350f; color: #fcd34d; }\n\n/* ── 실시간 점검 (2026-10-02) — 탭 줄은 2026-11-02 부터 SQL 편집과 같은 .file-tabs-container(위 .plsqled-filetabs-row) ── */\n\n.plsqled-badge.warn { background: #f59e0b; color: #fff; }\n.plsqled-lint-table tbody tr { cursor: pointer; }\n.plsqled-lint-table tbody tr:hover td { background: rgba(59, 130, 246, 0.06); }\n.plsqled-lint-sev { display: inline-block; font-size: 10px; font-weight: 700; padding: 0 6px; margin-right: 6px; border-radius: 8px; }\n.plsqled-lint-error .plsqled-lint-sev { background: #fee2e2; color: #b91c1c; }\n.plsqled-lint-warning .plsqled-lint-sev { background: #fef3c7; color: #92400e; }\n\n[data-theme=\"dark\"] .plsqled-topbar { background: var(--color-bg); border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-filetabs-row { border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .plsqled-lint-error .plsqled-lint-sev { background: rgba(185, 28, 28, 0.2); color: #fca5a5; }\n[data-theme=\"dark\"] .plsqled-lint-warning .plsqled-lint-sev { background: rgba(217, 119, 6, 0.2); color: #fcd34d; }\n\n[data-theme=\"dark\"] .plsqled-result-collapse { color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .plsqled-result-collapse:hover { color: var(--color-text); background: var(--color-hover); }\n[data-theme=\"dark\"] .plsqled-conflict-bar { background: rgba(180, 83, 9, 0.14); border-bottom-color: #b45309; }\n[data-theme=\"dark\"] .plsqled-conflict-bar .plsqled-conflict-head { color: #fcd34d; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
